exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.disabled[data-v-2e459e4c]{pointer-events:none}.pagination[data-v-2e459e4c]{justify-content:flex-end!important}.pagination .page-stats[data-v-2e459e4c]{align-items:center}[dir=ltr] .pagination .page-stats[data-v-2e459e4c]{margin-right:5px}[dir=rtl] .pagination .page-stats[data-v-2e459e4c]{margin-left:5px}i[data-v-2e459e4c]{color:#4caf50}.pagination__item1[data-v-2e459e4c]{display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:34px;width:34px;text-decoration:none;transition:.3s cubic-bezier(0,0,.2,1)}[dir] .pagination__item1[data-v-2e459e4c]{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);border-radius:4px;background:transparent;margin:.3rem;background-color:#4caf50}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e459e4c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pagination.vue
// module id = 558
// module chunks = 0